import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// --- PrimeNG ---
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';

// --- Overlay Panel ---
import { CartDialogComponent } from './cart-dialog.component';

// --- Components ---
import { CounterModule } from '@components/counter/counter.module';
import { ImageDefaultModule } from '@components/image-default/image-default.module';

// --- Directives ---
import { DirectivesModule } from '@directives/directives.module';

@NgModule({
	declarations: [CartDialogComponent],
	imports: [
		CommonModule,
		RouterModule,

		// --- PrimeNG ---
		ButtonModule,
		DividerModule,

		// --- Components ---
		CounterModule,
		ImageDefaultModule,

		// --- Directives ---
		DirectivesModule,
	],
	exports: [CartDialogComponent],
})
export class CartDialogModule {}
